const common = {
  viewBox: '0 0 48 48',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2.2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};

export function PhoneIcon() {
  return (
    <svg {...common} viewBox="0 0 24 24">
      <path d="M7.2 3.5 4.8 5.1c-.8.5-1.1 1.5-.8 2.4 2.2 6.4 6.1 10.3 12.5 12.5.9.3 1.9 0 2.4-.8l1.6-2.4c.5-.7.3-1.7-.4-2.2l-3.1-2.3c-.7-.5-1.6-.4-2.2.2l-1.3 1.3a15 15 0 0 1-3.3-3.3l1.3-1.3c.6-.6.7-1.5.2-2.2L9.4 3.9c-.5-.7-1.5-.9-2.2-.4Z"/>
    </svg>
  );
}

export function ChevronDownIcon() {
  return (
    <svg {...common} viewBox="0 0 16 16">
      <path d="m4 6 4 4 4-4"/>
    </svg>
  );
}

export function EstimateIcon() {
  return (
    <svg {...common} viewBox="0 0 32 32">
      <rect x="5" y="7" width="22" height="21" rx="2"/>
      <path d="M10 4v6M22 4v6M5 13h22M10 18h4M10 23h3M18 18h4"/>
    </svg>
  );
}

export function ServiceIcon({ type }) {
  if (type === 'estimate') {
    return (
      <svg {...common}>
        <rect x="10" y="8" width="28" height="32" rx="2"/>
        <path d="M17 5v7M31 5v7M10 17h28M17 25h8M17 31h14"/>
        <path d="m29 25 2 2 4-5"/>
      </svg>
    );
  }

  if (type === 'installation') {
    return (
      <svg {...common}>
        <path d="m6 21 18-12 18 12M10 19v23h28V19"/>
        <path d="M15 42V23h18v19M15 29h18M15 35h18"/>
      </svg>
    );
  }

  return (
    <svg {...common}>
      <path d="M29.5 9.5a10 10 0 0 0-11.8 12.8L7 33l8 8 10.7-10.7a10 10 0 0 0 12.8-11.8l-6 6-6-2-2-6 6-6Z"/>
      <path d="m10.5 34.5 3 3"/>
    </svg>
  );
}

export function StatIcon({ type }) {
  if (type === 'experience') {
    return (
      <svg {...common}>
        <path d="M24 5 39 11v11c0 10-6.2 17-15 21-8.8-4-15-11-15-21V11l15-6Z"/>
        <path d="m17 24 5 5 10-11"/>
      </svg>
    );
  }

  if (type === 'doors') {
    return (
      <svg {...common}>
        <path d="m7 20 17-11 17 11M10 18v24h28V18"/>
        <path d="M15 42V23h18v19M15 29h18M15 35h18"/>
      </svg>
    );
  }

  if (type === 'guarantee') {
    return (
      <svg {...common}>
        <circle cx="24" cy="21" r="13"/>
        <path d="m24 13 2.5 5 5.5.8-4 3.9.9 5.5-4.9-2.6-4.9 2.6.9-5.5-4-3.9 5.5-.8 2.5-5Z"/>
        <path d="m16 32-3 11 11-5 11 5-3-11"/>
      </svg>
    );
  }

  return (
    <svg {...common}>
      <circle cx="24" cy="25" r="6"/>
      <path d="M13 42c1.2-6.1 5-10 11-10s9.8 3.9 11 10"/>
      <path d="m7 9.4.65 1.7 1.85.1-1.45 1.2.5 1.8L7 13.25l-1.55.95.5-1.8-1.45-1.2 1.85-.1L7 9.4Z"/>
      <path d="m15 5.4.65 1.7 1.85.1-1.45 1.2.5 1.8-1.55-.95-1.55.95.5-1.8-1.45-1.2 1.85-.1.65-1.7Z"/>
      <path d="m24 3.4.65 1.7 1.85.1-1.45 1.2.5 1.8-1.55-.95-1.55.95.5-1.8-1.45-1.2 1.85-.1.65-1.7Z"/>
      <path d="m33 5.4.65 1.7 1.85.1-1.45 1.2.5 1.8-1.55-.95-1.55.95.5-1.8-1.45-1.2 1.85-.1.65-1.7Z"/>
      <path d="m41 9.4.65 1.7 1.85.1-1.45 1.2.5 1.8-1.55-.95-1.55.95.5-1.8-1.45-1.2 1.85-.1.65-1.7Z"/>
    </svg>
  );
}

export function ContactIcon({ type }) {
  if (type === 'phone') {
    return (
      <svg {...common}>
        <path d="M15 7 9.5 10.5c-1.7 1.1-2.4 3.2-1.7 5.1 4.7 13.5 13 21.8 26.5 26.5 1.9.7 4-.1 5.1-1.7L43 35c1-1.6.7-3.7-.8-4.8l-6.5-4.7c-1.5-1.1-3.6-.9-4.9.4l-2.7 2.7a32 32 0 0 1-8.7-8.7l2.7-2.7c1.3-1.3 1.5-3.4.4-4.9l-4.7-6.5C16.7 4.3 14.6 4 13 5"/>
      </svg>
    );
  }

  if (type === 'email') {
    return (
      <svg {...common}>
        <rect x="6" y="10" width="36" height="28" rx="3"/>
        <path d="m8 13 16 13 16-13"/>
      </svg>
    );
  }

  if (type === 'location') {
    return (
      <svg {...common}>
        <path d="M39 21c0 11-15 22-15 22S9 32 9 21a15 15 0 1 1 30 0Z"/>
        <circle cx="24" cy="21" r="5"/>
      </svg>
    );
  }

  return (
    <svg {...common}>
      <circle cx="24" cy="24" r="18"/>
      <path d="M24 14v11l8 5"/>
    </svg>
  );
}
